import React, { useEffect, useState } from "react";
import CustomSelect from "../../Base/CustomSelect";
import Amount from "../../Base/Amount";
import DatePicker from "react-datepicker";
import { baseURL, isMainNet } from "../../utils/config";
import { FaWhatsapp, FaTwitter, FaTelegram } from "react-icons/fa";

import {
  NETWORKS_MAINNET,
  NETWORKS_TESTNET,
  networkIcons,
  tokenIcons,
} from "../../utils/constants";

export default function Request({
  data,
  isConnected,
  isSignIn,
  connectWallet,
  sendPay,
  generateSignature,
  chain,
  changeNetwork,
  isNetworkChangeSuccess,
}) {
  const [form, setForm] = useState({
    network: "",
    token: "",
    description: "",
    amount: "",
    expirationDate: "",
    currency: "$",
  });
  const [networks, setNetworks] = useState([]);
  const [tokens, setTokens] = useState([]);
  const [currentSelectedNetwork, setCurrentSelectedNetwork] = useState(
    networks[0]
  );
  const [currentSelectedToken, setCurrentSelectedToken] = useState(tokens[0]);
  // useEffect(() => {
  //   if (isNetworkChangeSuccess) {
  //     generateSignature();
  //   }
  // }, [isNetworkChangeSuccess]);

  const checkCurrentSelectedNetwork = () => {
    return new Promise((resolve, reject) => {
      const getChainId =
        isMainNet === "true"
          ? NETWORKS_MAINNET[form.network]
          : NETWORKS_TESTNET[form.network];

      if (getChainId && getChainId != chain?.id) {
        changeNetwork(getChainId);
        resolve(getChainId); // Resolve the Promise with the updated chain ID
      } else {
        resolve(chain?.id); // Resolve with the existing chain ID if no change needed
      }
    });
  };

  useEffect(() => {
    const func = async () => {
      const updatedChainId = await checkCurrentSelectedNetwork();
    };
    func();
  }, [form.network, chain]);
  useEffect(() => {
    if (currentSelectedNetwork?.id) {
      const selectedNetwork = networks.find(
        (x) => x.value == currentSelectedNetwork.value
      );
      const temp = selectedNetwork?.token.map((x) => ({
        ...x,
        icon: tokenIcons[x.value],
      }));

      setTokens(temp);
      setCurrentSelectedToken(temp[0]);
      setForm({
        ...form,
        token: temp[0].value,
      });
    }
  }, [currentSelectedNetwork]);

  useEffect(() => {
    let networksList = {};

    data?.variants?.forEach((item, index) => {
      if (!networksList[item.networkId]) {
        networksList[item.networkId] = {
          id: String(index + 1),
          value: item.networkId,
          icon: networkIcons[item.networkId],
          token: [
            {
              value: item.token.name,
              id: String(index + 1),
              contract: item.token.contract,
              icon: tokenIcons[item.token.name],
            },
          ],
        };
      } else {
        networksList[item.networkId].token.push({
          value: item.token.name,
          id: String(index + 1),
          contract: item.token.contract,
        });
      }
    });
    if (Object.keys(data).length) {
      const temp = {
        ...form,
        amount: Number(data?.amountUsd).toFixed(2),
        description: data?.reason,
        expirationDate: new Date(data?.expiresAt),
      };
      if (Object.keys(networksList).length) {
        const getNetworkName =
          isMainNet === "true"
            ? NETWORKS_MAINNET[chain?.id]
            : NETWORKS_TESTNET[chain?.id];
        
        let network = null;
        let token = null;
        const newNetwork = networksList[getNetworkName];
        if (newNetwork && Object.keys(newNetwork).length) {
          network = networksList[getNetworkName];
          token = networksList[getNetworkName].token[0];

          temp.network = networksList[getNetworkName].value;
          temp.token = networksList[getNetworkName].token[0].value;
        } else {
          network = Object.values(networksList)[0];
          token = Object.values(networksList)[0].token[0];

          temp.network = Object.values(networksList)[0].value;
          temp.token = Object.values(networksList)[0].token[0].value;
        }

        setCurrentSelectedNetwork(network);
        setCurrentSelectedToken(token);
      }

      setForm(temp);
    }
    setNetworks(Object.values(networksList));
  }, [data]);

  const onChangeInput = (input) => (e) => {
    setForm((form) => ({ ...form, [input]: e.target.value }));
  };
  const updateForm = (data) => {
    setForm((form) => ({ ...form, ...data }));
  };
  const changeMedium = (key) => (item) => updateForm({ [key]: item.value });
  const networkListIndex = React.useMemo(() => {
    if (form.network !== "") {
      return networks.findIndex((item) => item.value === form.network);
    }
    return null;
    // eslint-disable-next-line
  }, []);
  const tokensListIndex = React.useMemo(() => {
    if (form.token !== "") {
      return tokens.findIndex((item) => item.value === form.token);
    }
    return null;
    // eslint-disable-next-line
  }, []);

  const sendPaymentButtons = () => {
    if (data.status === "Expired") {
      return (
        <button disabled className="button primary">
          Expired
        </button>
      );
    }
    if (data.status === "Paid") {
      return (
        <button disabled className="button primary">
          Paid
        </button>
      );
    }
    if (isConnected && isSignIn) {
      return (
        <button
          onClick={async () => {
            checkCurrentSelectedNetwork().then((rex) =>
              sendPay({
                networkId: form.network,
                token: currentSelectedToken.contract,
                amount: form.amount,
              })
            );
          }}
          className="button primary"
        >
          Send Payment
        </button>
      );
    } else if (isConnected && !isSignIn) {
      return (
        <button onClick={generateSignature} className="button primary">
          Sign In
        </button>
      );
    } else {
      return (
        <button onClick={connectWallet} className="button primary">
          Connect Wallet
        </button>
      );
    }
  };

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        minWidth: "616px",
      }}
    >
      <div
        className="request"
        style={{
          paddingTop: "20px",
          paddingBottom: "20px",
          marginBottom: "10px",
        }}
      >
        <h5 style={{ marginBottom: "20px" }}>
          <span className="purple"></span>Profile Information
        </h5>
        <div className="previewInfo__head">
          <div>
            <div
              className="avatar"
              style={{
                width: "117px",
                height: "121px",
              }}
            >
              <img
                // src={process.env.PUBLIC_URL + "/images/avatar.png"}
                src={
                  !!data?.receiverImage
                    ? `${baseURL}/images/${data?.receiverImage}`
                    : process.env.PUBLIC_URL + "/images/avatar.png"
                }
                alt="avatar"
              />
            </div>
            {/* icons */}
            {/* <div
              style={{
                display: "flex",
                justifyContent: "space-evenly",
                alignItems: "center",
                marginTop: "15px",
              }}
            >
              <span
                style={{
                  cursor: "pointer",
                }}
              >
                <FaWhatsapp size={"20px"} fill="#17a2b8" />
              </span>
              <span
                style={{
                  cursor: "pointer",
                }}
              >
                <FaTwitter size={"20px"} fill="#17a2b8" />
              </span>

              <span
                style={{
                  cursor: "pointer",
                }}
              >
                <FaTelegram size={"20px"} fill="#17a2b8" />
              </span>
            </div> */}
            {/*  */}
          </div>
          <div>
            <h4 style={{ textTransform: "capitalize" }}>
              {!!data?.receiverName?data?.receiverName:"receiver"}
            </h4>
            <span className="previewInfo__body">
              {!!data?.receiverDescription?data?.receiverDescription:""}
              
            </span>
          </div>
        </div>
      </div>
      <div className="request">
        <h5>
          <span className="purple"></span>Payment Request
        </h5>
        <div className="request__row">
          <label htmlFor="">Network</label>
          <CustomSelect
            currentSelected={currentSelectedNetwork}
            setCurrentSelected={setCurrentSelectedNetwork}
            list={networks}
            selected={networks[networkListIndex]}
            onChange={changeMedium("network")}
          />
        </div>
        <div className="request__row">
          <label htmlFor="">Token</label>
          <CustomSelect
            currentSelected={currentSelectedToken}
            setCurrentSelected={setCurrentSelectedToken}
            list={tokens}
            selected={tokens[tokensListIndex]}
            onChange={changeMedium("token")}
          />
        </div>
        <div className="input__outer">
          <label htmlFor="">Expiry Date</label>
          <div className="input">
            <DatePicker
              disabled
              onChange={(date) => updateForm({ expirationDate: date })}
              placeholderText={"dd-mm-yyyy"}
              selected={form.expirationDate}
              startDate={form.expirationDate}
            />
          </div>
        </div>
        <Amount
          disabled={true}
          onChangeInput={onChangeInput}
          form={form}
          updateForm={updateForm}
        />
        <div className="input__outer mb">
          <label htmlFor="">Description</label>
          <div className="input">
            <textarea
              disabled
              name=""
              id=""
              cols="30"
              rows="3"
              value={form.description}
              onChange={onChangeInput("description")}
            ></textarea>
          </div>
        </div>
        <div className="request__footer full">{sendPaymentButtons()}</div>
      </div>
    </div>
  );
}
